<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search v-model="form.user_name" placeholder="请输入搜索关键词" @search="onSearch"></van-search>
			<van-dropdown-menu>
				<van-dropdown-item v-model="form.approval_status" :options="dropdownList" @change="onSearch" />
			</van-dropdown-menu>
		</van-sticky>

		<van-list
			v-model="list.loading"
			:finished="list.finished"
			finished-text="没有更多了"
			@load="onLoad"
			style="padding-bottom: 50px;"
		>
			<van-cell
				class="item-list"
				v-for="item in list.list"
				:key="item.id"
				@click="approvalDetails(item.process_type, item.apply_id, item.approval_status)"
			>
				<div class="user-title">
					<span class="user-title-name" style="font-weight: 600;">
						<van-icon name="todo-list-o" />
						{{item.process_name}}
					</span>
					<span class="user-title-date" style="float: right;">{{item.apply_date}}</span>
				</div>
				<div class>
					<van-icon name="user-o" />
					{{item.user_name}}
				</div>
				<div class>
					<van-icon name="apps-o" />
					{{process_type[item.process_type].text}}
				</div>
				<van-tag
					class="item-tag"
					plain
					:type="tagPrimary[item.approval_status].value"
				>{{tagPrimary[item.approval_status].text}}</van-tag>
			</van-cell>
		</van-list>

		<van-tabbar v-model="activeName">
			<van-tabbar-item name="add" icon="add-o" to="/review">新的申请</van-tabbar-item>
			<van-tabbar-item name="approval" icon="clock-o" to="/review/approval">我的审批</van-tabbar-item>
			<van-tabbar-item name="list" icon="upgrade" to="/review/list">提交记录</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
import { approvalList } from "@/api/review";
// import { getToken } from "@/utils/auth";

export default {
	components: {
		navbar
	},
	data() {
			// let userId = this.$router.currentRoute.params.userId;
		return {
			activeName: "approval",
			title: "我的审批",
			dropdownList: [
				{ text: "未审批", value: 0 },
				{ text: "通过", value: 1 },
				{ text: "拒绝", value: 2 }
			],
			form: {
				requestType: "my_approval_list",
				page: 1,
				limit: 10,
				approval_status: 0,
				user_name: ""
			},
			list: {
				list: [],
				loading: false,
				finished: false
			},
			process_type: [
				{ text: "请假", value: 0 },
				{ text: "费用", value: 1 },
				{ text: "出差", value: 2 },
				{ text: "报备", value: 3 },
				{ text: "保证金", value: 4 },
				{ text: "采购支付", value: 5 },
				{ text: "用章", value: 6 },
				{ text: "报销", value: 7 }
			],
			tagPrimary: [
				{ text: "未结束", value: "primary" },
				{ text: "已结束", value: "success" },
				{ text: "拒绝", value: "warning" }
			]
		};
	},
	activated() {
		if (this.$route.params.refresh != true) {
			this.list.list = [];
			this.activeName = "approval";
			this.list.finished = false;
			this.form.page = 1;
			this.form.approval_status = 0;
			this.list.user_name = "";
			this.onLoad();
		}
	},
	methods: {
		onSearch() {
			this.form.page = 1;
			this.list.finished = false;
			this.onLoad();
		},
		onLoad() {
			approvalList(this.form)
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.list.finished = true;
					}
					if (this.form.page != 1) {
						this.list.list = this.list.list.concat(res.obj.rows);
					} else {
						this.list.list = res.obj.rows;
					}

					this.form.page += 1;
					this.list.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.list.loading = false;
					this.list.finished = true;
					return Toast.fail("数据异常");
				});
		},
		approvalDetails(type, id, status) {
			let p = false;
			if (status == 0) {
				p = true;
			}
			console.log(status);
			this.$router.push({
				path: "/review/details",
				query: { type: type, id: id, p: p }
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.user-title-date {
	font-size: 12px;
}

.item-list > div {
	position: relative;
	.item-tag {
		position: absolute;
		right: 5px;
		bottom: 5px;
	}
}
</style>
